// GENERATED by art-src/export_army.py from the concept walk atlas (Art/UI Redesign/Map/army-animation-preview-2026-10-15):
// the animated army's sprite sets — per scale, one atlas per movement kind (a row of eight walking frames), the cell size,
// the shared ground-contact anchor, the union footprint of all eight frames (the glow is not painted in these) and each
// frame's painted rect, all in the atlas's pixels. The squad walks LEFT as painted; the renderer mirrors the cell for rightward travel: the anchor's x
// becomes cell.w − anchor.x and the union's x becomes cell.w − (union.x + union.w). Do not edit by hand.
export interface ArmyRect { x: number; y: number; w: number; h: number }
export interface ArmySet {
  scale: number;
  cell: [number, number];
  anchor: [number, number];
  union: ArmyRect;
  frames: ArmyRect[];
  files: Record<"attack" | "support" | "return", string>;
}
export interface ArmyData { frames: number; kinds: string[]; cycleMs: number; source: string; sets: Record<string, ArmySet> }
export const ARMY: ArmyData = {
  "frames": 8,
  "kinds": [
    "attack",
    "support",
    "return"
  ],
  "cycleMs": 1000,
  "source": "army-walk-atlas.png",
  "sets": {
    "3x": {
      "scale": 3,
      "cell": [
        238,
        190
      ],
      "anchor": [
        125.98,
        165.97
      ],
      "union": {
        "x": 23.0,
        "y": 23.0,
        "w": 192.0,
        "h": 143.9
      },
      "frames": [
        {
          "x": 26.3,
          "y": 29.1,
          "w": 188.6,
          "h": 137.9
        },
        {
          "x": 25.3,
          "y": 23.5,
          "w": 187.2,
          "h": 143.0
        },
        {
          "x": 26.9,
          "y": 23.5,
          "w": 188.1,
          "h": 143.0
        },
        {
          "x": 26.9,
          "y": 25.3,
          "w": 186.3,
          "h": 141.1
        },
        {
          "x": 23.0,
          "y": 24.4,
          "w": 189.5,
          "h": 142.0
        },
        {
          "x": 27.4,
          "y": 23.9,
          "w": 185.8,
          "h": 142.5
        },
        {
          "x": 28.0,
          "y": 23.0,
          "w": 185.4,
          "h": 143.4
        },
        {
          "x": 25.7,
          "y": 23.5,
          "w": 185.4,
          "h": 142.5
        }
      ],
      "files": {
        "attack": "army-attack@3x.webp",
        "support": "army-support@3x.webp",
        "return": "army-return@3x.webp"
      }
    },
    "2x": {
      "scale": 2,
      "cell": [
        158,
        126
      ],
      "anchor": [
        83.65,
        110.32
      ],
      "union": {
        "x": 15.0,
        "y": 15.0,
        "w": 128.0,
        "h": 95.94
      },
      "frames": [
        {
          "x": 17.2,
          "y": 19.0,
          "w": 125.7,
          "h": 91.9
        },
        {
          "x": 16.5,
          "y": 15.3,
          "w": 124.8,
          "h": 95.3
        },
        {
          "x": 17.6,
          "y": 15.3,
          "w": 125.4,
          "h": 95.3
        },
        {
          "x": 17.6,
          "y": 16.6,
          "w": 124.2,
          "h": 94.1
        },
        {
          "x": 15.0,
          "y": 15.9,
          "w": 126.4,
          "h": 94.7
        },
        {
          "x": 18.0,
          "y": 15.6,
          "w": 123.9,
          "h": 95.0
        },
        {
          "x": 18.3,
          "y": 15.0,
          "w": 123.6,
          "h": 95.6
        },
        {
          "x": 16.8,
          "y": 15.3,
          "w": 123.6,
          "h": 95.0
        }
      ],
      "files": {
        "attack": "army-attack@2x.webp",
        "support": "army-support@2x.webp",
        "return": "army-return@2x.webp"
      }
    }
  }
};
